import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import "./privacyStyle.css";

export default function LovePrivacySettings({ profileId, isOwner }) {
  const { user } = useSelector((state) => ({ ...state }));
  const [settings, setSettings] = useState({
    showTotalClicks: "public",
    showUsersList: "friends",
    showRanking: "friends",
    enableLove: true,
  });
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    if (isOwner) {
      fetchSettings();
    }
  }, [profileId, isOwner]);

  const fetchSettings = async () => {
    try {
      // Os settings são retornados junto com o stats
      // Se necessário criar endpoint específico
      setSettings({
        showTotalClicks: "public",
        showUsersList: "friends",
        showRanking: "friends",
        enableLove: true,
      });
    } catch (error) {
      console.error("Erro ao carregar configurações:", error);
    }
  };

  const handleSettingChange = (key, value) => {
    setSettings((prev) => ({
      ...prev,
      [key]: value,
    }));
    setSaved(false);
  };

  const handleSaveSettings = async () => {
    try {
      setLoading(true);
      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/profiles/${profileId}/love/privacy`,
        settings,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (error) {
      console.error("Erro ao salvar configurações:", error);
      alert("Erro ao salvar configurações");
    } finally {
      setLoading(false);
    }
  };

  if (!isOwner) return null;

  return (
    <div className="love_privacy_container">
      <button
        className="privacy_settings_btn"
        onClick={() => setShowSettings(!showSettings)}
      >
        <span>⚙️</span>
        {showSettings ? "Ocultar Configurações" : "Configurações de Privacidade"}
      </button>

      {showSettings && (
        <div className="privacy_settings_panel">
          {/* Toggle Ativar/Desativar */}
          <div className="setting_group">
            <label className="setting_label">
              <input
                type="checkbox"
                checked={settings.enableLove}
                onChange={(e) =>
                  handleSettingChange("enableLove", e.target.checked)
                }
              />
              <span>Ativar botão de amor do perfil</span>
            </label>
            <p className="setting_help">
              Quando desativado, ninguém pode amar seu perfil
            </p>
          </div>

          {/* Visibilidade do Total */}
          <div className="setting_group">
            <label className="setting_label_title">
              Total de amores recebidos
            </label>
            <div className="setting_options">
              <label className="radio_option">
                <input
                  type="radio"
                  name="showTotalClicks"
                  value="public"
                  checked={settings.showTotalClicks === "public"}
                  onChange={(e) =>
                    handleSettingChange("showTotalClicks", e.target.value)
                  }
                />
                <span>🌐 Público</span>
              </label>
              <label className="radio_option">
                <input
                  type="radio"
                  name="showTotalClicks"
                  value="friends"
                  checked={settings.showTotalClicks === "friends"}
                  onChange={(e) =>
                    handleSettingChange("showTotalClicks", e.target.value)
                  }
                />
                <span>👥 Apenas Amigos</span>
              </label>
              <label className="radio_option">
                <input
                  type="radio"
                  name="showTotalClicks"
                  value="private"
                  checked={settings.showTotalClicks === "private"}
                  onChange={(e) =>
                    handleSettingChange("showTotalClicks", e.target.value)
                  }
                />
                <span>🔒 Privado</span>
              </label>
            </div>
            <p className="setting_help">
              Quem pode ver quantos amores você recebeu
            </p>
          </div>

          {/* Visibilidade da Lista */}
          <div className="setting_group">
            <label className="setting_label_title">
              Lista de usuários que amaram
            </label>
            <div className="setting_options">
              <label className="radio_option">
                <input
                  type="radio"
                  name="showUsersList"
                  value="public"
                  checked={settings.showUsersList === "public"}
                  onChange={(e) =>
                    handleSettingChange("showUsersList", e.target.value)
                  }
                />
                <span>🌐 Público</span>
              </label>
              <label className="radio_option">
                <input
                  type="radio"
                  name="showUsersList"
                  value="friends"
                  checked={settings.showUsersList === "friends"}
                  onChange={(e) =>
                    handleSettingChange("showUsersList", e.target.value)
                  }
                />
                <span>👥 Apenas Amigos</span>
              </label>
              <label className="radio_option">
                <input
                  type="radio"
                  name="showUsersList"
                  value="private"
                  checked={settings.showUsersList === "private"}
                  onChange={(e) =>
                    handleSettingChange("showUsersList", e.target.value)
                  }
                />
                <span>🔒 Privado</span>
              </label>
            </div>
            <p className="setting_help">
              Quem pode ver a lista de pessoas que amaram seu perfil
            </p>
          </div>

          {/* Visibilidade do Ranking */}
          <div className="setting_group">
            <label className="setting_label_title">Ranking de Fãs</label>
            <div className="setting_options">
              <label className="radio_option">
                <input
                  type="radio"
                  name="showRanking"
                  value="public"
                  checked={settings.showRanking === "public"}
                  onChange={(e) =>
                    handleSettingChange("showRanking", e.target.value)
                  }
                />
                <span>🌐 Público</span>
              </label>
              <label className="radio_option">
                <input
                  type="radio"
                  name="showRanking"
                  value="friends"
                  checked={settings.showRanking === "friends"}
                  onChange={(e) =>
                    handleSettingChange("showRanking", e.target.value)
                  }
                />
                <span>👥 Apenas Amigos</span>
              </label>
              <label className="radio_option">
                <input
                  type="radio"
                  name="showRanking"
                  value="private"
                  checked={settings.showRanking === "private"}
                  onChange={(e) =>
                    handleSettingChange("showRanking", e.target.value)
                  }
                />
                <span>🔒 Privado</span>
              </label>
            </div>
            <p className="setting_help">
              Quem pode ver o ranking dos seus maiores fãs
            </p>
          </div>

          {/* Botões de Ação */}
          <div className="setting_actions">
            <button
              className="save_btn"
              onClick={handleSaveSettings}
              disabled={loading}
            >
              {loading ? "Salvando..." : "Salvar Configurações"}
            </button>
            {saved && <span className="saved_message">✓ Salvo com sucesso</span>}
          </div>
        </div>
      )}
    </div>
  );
}
